/**
 * Constants for NotificationThreadList component
 */

export const NOTIFICATION_PAGE_SIZE = 30;
export const SIDEBAR_INITIAL_HEIGHT = 57;
export const FILTER_HEIGHT = 50;
export const SEARCH_HEIGHT = 50;

export const DEACTIVATED_CHANNEL_ID = '99';
